export interface PopoverClampInput {
  /** Viewport x of the trigger's right edge, in CSS pixels. */
  triggerRight: number;
  /** Rendered width of the panel, in CSS pixels. */
  panelWidth: number;
  /** `window.innerWidth` at measure time. */
  viewportWidth: number;
  /** Minimum gap kept between the panel and each viewport edge. */
  gutter?: number;
}

/**
 * Horizontal offset for a right-aligned popover that is anchored to a
 * trigger near a viewport edge. Apply the result as `right: -offset`, so a
 * positive value pushes the panel right (away from a clipped left edge) and
 * a negative value pulls it back from the right edge. Returns 0 when the
 * panel already fits, when it has not been measured yet (jsdom reports a
 * zero width), or when the panel is wider than the viewport minus gutters.
 */
export function clampPopoverOffset({
  triggerRight,
  panelWidth,
  viewportWidth,
  gutter = 16,
}: PopoverClampInput): number {
  if (
    !Number.isFinite(triggerRight) ||
    !Number.isFinite(panelWidth) ||
    !Number.isFinite(viewportWidth)
  ) {
    return 0;
  }
  if (panelWidth <= 0 || viewportWidth <= 0) return 0;

  const width = Math.min(panelWidth, Math.max(0, viewportWidth - gutter * 2));
  const left = Math.max(
    gutter,
    Math.min(triggerRight - width, viewportWidth - gutter - width),
  );
  return left + width - triggerRight;
}
